import "@/lib/effectGuard";
import "@/lib/install";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Lets the app be installed (desktop, Android, iPhone home screen). Production only, so local
// development never gets a stale copy.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* installing just won't be offered */
    });
  });
}
